import { useState, useEffect } from 'react';

export function usePublishRequestable() {
    const [requestable, setRequestable] = useState<boolean>();

    useEffect(() => {
        // TODO: /v1/media/devices/:device_id/statusをPUTする権限があるか確認する
        setTimeout(() => {
            setRequestable(true);
        }, 1000);
    }, []);

    return requestable;
}
